import { ReplaySubject } from 'rxjs';
import { switchMap, catchError, tap, share } from 'rxjs/operators';
import { fetchJson } from './http.js';
import { showError } from './ui.js';

/**
 * Shared Observable that fetches the subject list once and caches the result.
 * Emits an array of { id, name, back_locale } objects, ordered alphabetically by name.
 */
let subjects$ = fetchJson('/api/subjects').pipe(
    share({ connector: () => new ReplaySubject(1), resetOnRefCountZero: false })
);

/**
 * Populates the given <select> element with one <option> per subject fetched
 * from GET /api/subjects. The first blank option already present in the HTML
 * is preserved. Returns an Observable that completes after populating.
 */
export function populateSubjectSelect(selectEl) {
    return subjects$.pipe(
        tap((subjects) => {
            for (let subject of subjects) {
                let option = document.createElement('option');
                option.value = String(subject.id);
                option.textContent = subject.name;
                selectEl.appendChild(option);
            }
        }),
        catchError((err) => {
            showError(err);
            return [];
        })
    );
}
